import { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams, CodeSample } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import React from 'react';
import CodeBlock from '../CodeBlock';

export default class FrontendNextJsSample extends CodeSample {
  name = 'Next.js';
  language = 'language';
  codeType = CodeType.FRONTEND;
  tabIcon = '';
  commentChar = undefined;

  buildCode({ environment, notification, user }: BuildCodeParams): ReactNode {
    const npmInstall = `npm install notificationapi-js-client-sdk
# Or if you are using Yarn: yarn add notificationapi-js-client-sdk`;

    const code = `'use client';

import "notificationapi-js-client-sdk/dist/styles.css";
import { memo, useEffect } from "react";
const NotificationAPIComponent = memo((props) => {
  useEffect(() => {
    const loadNotificationAPI = async () => {
      const NotificationAPI = (await import("notificationapi-js-client-sdk")).default;
      const notificationapi = new NotificationAPI({
        clientId: '${environment.clientId}',
        userId: '${user.id}',
      });
      notificationapi.showInApp({
        root: "CONTAINER_DIV_ID",
      });
    };

    // Call the async function
    loadNotificationAPI();
  }, []);

  return <div id="CONTAINER_DIV_ID"></div>;
});

NotificationAPIComponent.displayName = 'NotificationAPIComponent';

export default NotificationAPIComponent;`;

    return (
      <>
        <CodeBlock language="bash" code={npmInstall} />

        <Paragraph>
          Create the following component and use it in your app:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }
}
